<div ngModelGroup="address">
    <!--First name && Last name-->
    <input-wrap>
        <input class="input"
               type="text"
               name="firstname"
               cy-addressAddFname
               required
               [muiInput]="'First name' | translate"
               [(ngModel)]="data.firstname"
               (blur)="onInputBlur()">
    </input-wrap>

    <input-wrap>
        <input class="input"
               type="text"
               name="lastname"
               cy-addressAddLame
               required
               [muiInput]="'Surname' | translate"
               [(ngModel)]="data.lastname"
               (blur)="onInputBlur()">
    </input-wrap>

    @if (searcher) {
    <div class="pos-relative"
         (offClick)="searcher.clear()"
         [offClickOff]="!searcher.hints.length">
        <input-wrap class="pos-relative"
                    [ngClass]="{'is-busy': searcher.status.busy}">
            <input class="input"
                   [class._is-open]="searcher.hints.length"
                   [muiInput]="'Find your address'"
                   type="text"
                   name="query"
                   autocomplete="off"
                   [(ngModel)]="searcher.query"
                   (keydown.enter)="searcher.search()">

            @if (searcher.status.busy) {
            <span class="pos-absolute top-3 right-3 bottom-0 flex flex-middle flex-justify-center pe-none">
                <i class="icon-loading"
                   aria-hidden="true"></i>
            </span>
            }

            <div class="pos-relative">
                <div class="pos-absolute right-0 left-0 z-5 bg-col-w p-l-2 p-b-2 p-r-2 b-l b-b b-r b-col-4 ng-hide dropdown-options overflow-y-scroll"
                     [ngClass]="{'ng-hide': !searcher.hints.length}"
                     style="max-height: 20em;"
                     role="listbox"
                     [attr.aria-hidden]="!searcher.hints.length"
                     [attr.tabindex]="searcher.hints.length ? 0 : -1">
                    <ul class="dropdown-options-inner m-t-1">
                        @for (hint of searcher.hints; track $index) {
                        <li class="flex flex-middle cursor-pointer no-wrap p-a-2 b-radius-7 dropdown-option"
                            role="option"
                            (click)="searcher.search(hint)">
                            <span class="w-12 p2 dropdown-option-label flex flex-justify-between flex-middle">
                                <p>
                                    <span class="block">{{$any(hint).Text}}</span>
                                    <span>{{hint.Description}}</span>
                                </p>
                                @if ($any(hint).Type === 'Street') {
                                <i class="icon-chevron-right"
                                   aria-hidden="true"></i>
                                }
                            </span>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </input-wrap>
    </div>
    }

    <toggle class="m-t-4 block"
            name="display_form"
            [(ngModel)]="canShowForm">
        <span class="p2 fs-3-l cursor-pointer"
              cy-addressAddUnfold>{{'Enter address manually' | translate}}</span>
    </toggle>

    <div [ngClass]="{'ng-hide': !canShowForm}">
        <!--Street Name-->
        <input-wrap>
            <input class="input"
                   type="text"
                   name="street_1"
                   required
                   cy-addressAddFirstLine
                   [muiInput]="'Address line 1' | translate"
                   [(ngModel)]="data.street_1"
                   (blur)="onInputBlur()">
        </input-wrap>

        <input-wrap>
            <input class="input"
                   type="text"
                   name="street_2"
                   cy-addressAddSecondLine
                   [muiInput]="'Address line 2' | translate"
                   [(ngModel)]="data.street_2"
                   (blur)="onInputBlur()">
        </input-wrap>

        <!--Post Code-->
        <input-wrap>
            <input class="input"
                   type="text"
                   name="postcode"
                   required
                   cy-addressAddPostcode
                   [muiInput]="'Postcode' | translate"
                   [(ngModel)]="data.postcode">
        </input-wrap>

        <!--Town-->
        <input-wrap>
            <input class="input"
                   type="text"
                   name="city"
                   required
                   cy-addressAddCity
                   [muiInput]="'Town/City' | translate"
                   [(ngModel)]="data.city"
                   (blur)="onInputBlur()">
        </input-wrap>

        <!--Region-->
        @if (!regions) {
        <input-wrap>
            <input class="input"
                   type="text"
                   name="region"
                   cy-addressAddRegion
                   [required]="regionRequired"
                   [muiInput]="'Region' | translate"
                   [(ngModel)]="data.region"
                   (blur)="onInputBlur()">
        </input-wrap>
        } @else {
        <input-wrap>
            <select class="input"
                    name="region_id"
                    [required]="regionRequired"
                    [muiInput]="'Region' | translate"
                    [(ngModel)]="data.region_id">
                <option value=""></option>
                @for (region of regions | orderBy: ['name']; track region.id) {
                <option [value]="region.id">{{region.name}}</option>
                }
            </select>
        </input-wrap>
        }

        <!--Phone-->
        <input-wrap>
            <input class="input"
                   type="text"
                   inputmode="numeric"
                   name="telephone"
                   required
                   validatePattern="telephone"
                   cy-addressAddPhone
                   [muiInput]="'Phone number' | translate"
                   [(ngModel)]="data.telephone"
                   (blur)="onInputBlur()">
        </input-wrap>
    </div>
</div>
